import React from 'react';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import api from '../iCONSAPI'
import { timeout } from '../utils'
import './LoginPage.css';

export default class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.onLogin = props.onLogin
    this.state = {
      isLoginButtonEnabled: false,  // NOTE: this should be false
      username: '',                 // NOTE: This should be empty
      password: '',                 // NOTE: This should be empty
    }
  }

  doLogin = (username, password) => {
    console.log("Try to login")
    timeout(api.timeout_ms, api.login(username, password))
      .then(response => {
        if (response.ok) {
          console.log("OK")
          this.onLogin()
        } else {
          console.log("FAIL")
          // TODO: Show invalid login details notification
          this.setState({ isLoginButtonEnabled: true })
        }
      })
      .catch(error => {
        console.log(error.message)
        this.setState({ isLoginButtonEnabled: true })
      })
  }

  handleUsernameChanged = (e, value) => {
    this.setState({
      isLoginButtonEnabled: this.state.password && value,
      username: value
    })
  }

  handlePasswordChanged = (e, value) => {
    this.setState({
      isLoginButtonEnabled: this.state.username && value,
      password: value
    })
  }

  handleLogin = () => {
    this.setState({ isLoginButtonEnabled: false })
    this.doLogin(this.state.username, this.state.password)
  }

  render() {
    return (
      <Paper className="paper-page-container">
        <h2>Log in to iCONS</h2>
        <TextField
          className="input-field"
          floatingLabelText="Username"
          value={this.state.username}
          onChange={this.handleUsernameChanged}
        /><br/>
        <TextField
          className="input-field"
          floatingLabelText="Password"
          value={this.state.password}
          type="password"
          onChange={this.handlePasswordChanged}
        /><br/>
        <RaisedButton
          className="input-button"
          label="Login"
          primary={true}
          disabled={!this.state.isLoginButtonEnabled}
          onTouchTap={this.handleLogin}
        />
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginPage.js